import Splide from '@splidejs/splide';

const EL = '.js-ProductsWidget';

export function initProductsWidget() {
  document.querySelectorAll(EL).forEach((element) => {
    if(!element.parentNode.hasAttribute('hidden') && !element.classList.contains('is-active')){
      new Splide(element, {
        autoWidth: true,
        pagination: true,
        arrows: true,
        omitEnd: true,
        focus: 0
      }).mount();
    }
  });
}

initProductsWidget()
